<template>
  <div>
    <div class="scheduler_section" :class="options.telehealthv2 ? 'telehealth-v2' : ''">
      <div v-if="options.telehealthv2">
        <div class="row mb-30">
          <div class="col-sm-6 col-lg-3">
            <span class="scheduleVisitTxt fs-18">Schedule Your Visits</span>
          </div>
        </div>
        <div class="form-group row mb-30">
          <div class="col-sm-6 col-lg-3">
            <div class="scheduler-heading mb-5">
              Visit Name
              <span v-b-popover.hover="'The visit name displays in the study portal.'" class="fa fa-info-circle ml-7"></span>
            </div>
            <input type="text" name="vistName" v-model.trim="telehealthVisit.telehealthVisitDTO.title" class="form-control" placeholder="Enter a name" />
          </div>
        </div>
        <div class="form-group row mb-30">
          <div class="col-sm-6 col-lg-3">
            <div class="scheduler-heading mb-5">
              Activity Name
              <span v-b-popover.hover="'The activity name displays in the app for the participant’s task to schedule the Telehealth visit. Recommended activity name under 36 characters.'" class="fa fa-info-circle ml-7"></span>
            </div>
            <input type="text" name="activityName" v-model.trim="telehealthVisit.telehealthVisitDTO.activityName" class="form-control" placeholder="i.e. Schedule your visit 1 appointment" :maxlength="maxChar" />
          </div>
        </div>
      </div>
      <div class="visit-types mb-36" v-if="telehealthVisit.telehealthVisitDTO.visitTypes">
        <div class="scheduler-heading mb-5">
          Select the type of visit to schedule
        </div>
        <span
          class="type"
          :class="{
            active_item: telehealthVisit.telehealthVisitDTO.visitTypes[0].selected === true
          }"
          @click="changeVisitType('Telehealth')"
        >
          <span class="icon type-telehealth"></span> &nbsp;
          <span
            :class="{
              activeText: telehealthVisit.telehealthVisitDTO.visitTypes[0].selected === true,
              'in-activeText': telehealthVisit.telehealthVisitDTO.visitTypes[0].selected === false
            }"
            >Video Call</span
          >
        </span>
        <span
          class="type"
          :class="{
            active_item: telehealthVisit.telehealthVisitDTO.visitTypes[1].selected === true
          }"
          @click="changeVisitType('In-person')"
        >
          <span class="icon in-person"></span> &nbsp;
          <span
            :class="{
              activeText: telehealthVisit.telehealthVisitDTO.visitTypes[1].selected === true,
              'in-activeText': telehealthVisit.telehealthVisitDTO.visitTypes[1].selected === false
            }"
            >Office Visit</span
          >
        </span>
        <span
          class="type"
          :class="{
            active_item: telehealthVisit.telehealthVisitDTO.visitTypes[2].selected === true
          }"
          @click="changeVisitType('Homevisit')"
        >
          <span class="icon office-visit"></span> &nbsp;
          <span
            :class="{
              activeText: telehealthVisit.telehealthVisitDTO.visitTypes[2].selected === true,
              'in-activeText': telehealthVisit.telehealthVisitDTO.visitTypes[2].selected === false
            }"
            >Home Visit</span
          >
        </span>
        <span
          class="type"
          :class="{
            active_item: telehealthVisit.telehealthVisitDTO.visitTypes[3].selected === true
          }"
          @click="changeVisitType('Phonecall')"
        >
          <span class="icon phone-call"></span> &nbsp;
          <span
            :class="{
              activeText: telehealthVisit.telehealthVisitDTO.visitTypes[3].selected === true,
              'in-activeText': telehealthVisit.telehealthVisitDTO.visitTypes[3].selected === false
            }"
            >Phone Call</span
          >
        </span>
      </div>
      <div class="visit-types mb-36">
        <div class="scheduler-heading mb-5">
          Select who will be able to schedule the visit
        </div>
        <span
          class="type"
          :class="{
            active_item: telehealthVisit.telehealthVisitDTO.configFor === 'participant'
          }"
          @click="changeScheduleVisitType('participant')"
        >
          <span class="icon participant-logo"></span> &nbsp;
          <span
            :class="{
              activeText: telehealthVisit.telehealthVisitDTO.configFor === 'participant',
              'in-activeText': telehealthVisit.telehealthVisitDTO.configFor !== 'participant',
              'not-allowed': telehealthVisit.telehealthVisitDTO.id
            }"
            >Participant</span
          >
        </span>
        <span
          class="type"
          :class="{
            active_item: telehealthVisit.telehealthVisitDTO.configFor === 'site'
          }"
          @click="changeScheduleVisitType('site')"
        >
          <span class="icon siteTeam-logo"></span> &nbsp;
          <span
            :class="{
              activeText: telehealthVisit.telehealthVisitDTO.configFor === 'site',
              'in-activeText': telehealthVisit.telehealthVisitDTO.configFor !== 'site',
              'not-allowed': telehealthVisit.telehealthVisitDTO.id
            }"
            >Site Team</span
          >
        </span>
      </div>
      <div class="pt-18 mb-16 clearfix telehealth_qs">
        How would you like your activity to be sent?
      </div>
      <span class="activity-mode">
        <span
          :class="{
            selected: activityMode === 'schedule',
            'in-activeText': activityMode !== 'schedule'
          }"
          @click="changeActivityMode('schedule')"
          ><img :src="activityModeIcon['schedule']" width="29" alt="Activity Mode Icon" />&nbsp;&nbsp;Scheduled</span
        >
        <span
          v-if="telehealthVisit.telehealthVisitDTO.configFor !== 'site'"
          :class="{
            selected: activityMode === 'both',
            'in-activeText': activityMode !== 'both'
          }"
          @click="changeActivityMode('both')"
          ><img :src="activityModeIcon['both']" width="58" alt="Activity Mode Icon" />&nbsp;&nbsp;Both scheduled and on-demand</span
        >
        <span
          v-if="telehealthVisit.telehealthVisitDTO.configFor !== 'site'"
          :class="{
            selected: activityMode === 'onDemand',
            'in-activeText': activityMode !== 'onDemand'
          }"
          @click="changeActivityMode('onDemand')"
          ><img :src="activityModeIcon['onDemand']" width="29" alt="Activity Mode Icon" />&nbsp;&nbsp;On-demand only</span
        >
      </span>
      <div :class="{ 'activity-mode-opacity': activityMode === 'onDemand' }" class="mt-14">
        <div class="visit-recording mb-36" v-if="THvisitRecordingState && THvisitRecordingState.visitLevel && telehealthVisit.telehealthVisitDTO.visitTypes && telehealthVisit.telehealthVisitDTO.visitTypes[0].selected">
          <div class="font-weight-bold pb-5">
            Allow this telehealth visit to be recorded
          </div>
          <input type="checkbox" id="checkbox" class="checkbox" v-model="telehealthVisit.telehealthVisitDTO.allowRecording" />
          <label for="checkbox" class="control-label">Enable recording features</label>
        </div>
        <div class="scheduler_types">
          <div v-if="options.telehealthv2" class="scheduler-heading mb-5">
            Which method would you like to schedule with?
          </div>
          <span
            class="scheduler_type"
            :class="{
              active_item: telehealthVisit.scheduler.type === 'milestone'
            }"
            v-on:click="changeType('milestone')"
          >
            <span class="type_icon_bg">
              <i class="fa fa-flag-o" aria-hidden="true"></i>
            </span>
            &nbsp;
            <span
              :class="{
                activeText: telehealthVisit.scheduler.type === 'milestone',
                'in-activeText': telehealthVisit.scheduler.type !== 'milestone'
              }"
              >Milestones</span
            >
          </span>
          <span
            class="scheduler_type"
            :class="{
              active_item: telehealthVisit.scheduler.type === 'custom'
            }"
            v-on:click="changeType('custom')"
          >
            <span class="type_icon_bg">
              <i class="fa fa-sliders" aria-hidden="true"></i>
            </span>
            &nbsp;
            <span
              :class="{
                activeText: telehealthVisit.scheduler.type === 'custom',
                'in-activeText': telehealthVisit.scheduler.type !== 'custom'
              }"
              >Custom frequency</span
            >
          </span>
        </div>
        <div class="pt-40" v-if="telehealthVisit.scheduler.type === 'milestone'">
          <div v-if="studyData.milestones && studyData.milestones.length > 0">
            <div class="scheduler-heading pb-5">
              Which milestones will your participants complete their telehealth visit?
              <span class="edit_milestone_link" v-on:click="updateMilestones()">Edit milestones</span>
            </div>
          </div>
          <div v-if="studyData.screeningMilestoneAllowed">
            <div :class="[telehealthVisit.scheduler.milestones && telehealthVisit.scheduler.milestones.indexOf(milestone.milestoneDay) < 0 ? 'milestone_card' : 'selected_completion_window']" :key="index" v-for="(milestone, index) in screeningMilestones">
              <div v-if="telehealthVisit.scheduler.milestones && milestone.isDoNotShowTimeline" class="notShownCSS" :class="[telehealthVisit.scheduler.milestones && telehealthVisit.scheduler.milestones.indexOf(milestone.milestoneDay) < 0 ? '' : 'selectedNotShownCSS']">
                Not shown
              </div>
              <div class="day_card" v-on:click="selectUnselectMileStone(milestone.milestoneDay)">
                <p class="m-0">Screening Milestone {{ index + 1 }}</p>
                <p class="m-0 day_text">Day {{ milestone.milestoneDay }}</p>
                <i v-if="telehealthVisit.scheduler.milestones && telehealthVisit.scheduler.milestones.indexOf(milestone.milestoneDay) >= 0" class="fa fa-check-circle" aria-hidden="true"></i>
              </div>
              <div class="completion-window  d-flex justify-content-between" v-if="telehealthVisit.scheduler.milestones && telehealthVisit.scheduler.milestones.indexOf(milestone.milestoneDay) >= 0">
                <p class="">Completion Window</p>
                <input type="number" placeholder="1 day" v-model="telehealthVisit.scheduler.completionWindows[milestone.milestoneDay]" v-on:blur="setCompletionWindows(milestone, telehealthVisit.scheduler.completionWindows[milestone.milestoneDay])" />
              </div>
            </div>
          </div>

          <div :class="[telehealthVisit.scheduler.milestones && telehealthVisit.scheduler.milestones.indexOf(milestone.milestoneDay) < 0 ? 'milestone_card' : 'selected_completion_window']" :key="index" v-for="(milestone, index) in regularMilestones">
            <div v-if="telehealthVisit.scheduler.milestones && milestone.isDoNotShowTimeline" class="notShownCSS" :class="[telehealthVisit.scheduler.milestones && telehealthVisit.scheduler.milestones.indexOf(milestone.milestoneDay) < 0 ? '' : 'selectedNotShownCSS']">
              Not shown
            </div>
            <div class="day_card" v-on:click="selectUnselectMileStone(milestone.milestoneDay)">
              <p class="m-0">Milestone {{ index + 1 }}</p>
              <p class="m-0 day_text">Day {{ milestone.milestoneDay }}</p>
              <i v-if="telehealthVisit.scheduler.milestones && telehealthVisit.scheduler.milestones.indexOf(milestone.milestoneDay) >= 0" class="fa fa-check-circle" aria-hidden="true"></i>
            </div>
            <div class="completion-window  d-flex justify-content-between" v-if="telehealthVisit.scheduler.milestones && telehealthVisit.scheduler.milestones.indexOf(milestone.milestoneDay) >= 0">
              <p class="">Completion Window</p>
              <input type="number" placeholder="1 day" v-model="telehealthVisit.scheduler.completionWindows[milestone.milestoneDay]" v-on:blur="setCompletionWindows(milestone, telehealthVisit.scheduler.completionWindows[milestone.milestoneDay])" />
            </div>
          </div>

          <div class="pt-20" v-if="telehealthVisit.telehealthVisitDTO.configFor !== 'site'">
            <label class="fw-normal">
              <input type="checkbox" name="isActivityOptional" v-model="telehealthVisit.scheduler.isActivityOptional" class="checkbox_position" />
              <span> Activity is optional and will be excluded from the compliance report</span>
            </label>
          </div>
          <div class="row">
            <div class="col-sm-12 p-0" v-if="options.validateFor === 'telehealthv2' && telehealthVisit.telehealthVisitDTO.configFor !== 'site'">
              <div class="pt-40">
                <div class="scheduler-heading">
                  How far in advance can a participant schedule their Telehealth visit?
                  <a class="color_grey cursor_pointer" data-toggle="modal" data-target="#completionModal">
                    <i class="fa fa-info-circle p-1"></i>
                  </a>
                </div>
                <input type="number" min="1" max="99" class="form-control completion_window_days" placeholder="Enter" v-model="telehealthVisit.scheduler.advanceScheduleDays" v-on:blur="calculateReminders(telehealthVisit.scheduler.completionWindow, telehealthVisit.scheduler.advanceScheduleDays)" />
                days
              </div>
            </div>
          </div>
        </div>
        <div class="row pt-40">
          <div v-if="!studyData.milestones || studyData.milestones.length == 0">
            <button type="button" class="btn btn-md btn-block create_milestone_btn br-25" v-on:click="updateMilestones()">
              Create milestones
            </button>
          </div>
        </div>
      </div>

      <div class="pt-40" v-if="telehealthVisit.scheduler.type === 'custom'" :class="{ 'scheduler-type-custom': activityMode === 'onDemand' }">
        <div class="pb-5 scheduler-heading">
          What frequency will your partcipants take this survey?
        </div>
        <div
          :class="{
            selected_milestone: telehealthVisit.scheduler.frequency && telehealthVisit.scheduler.frequency.type && f.type === telehealthVisit.scheduler.frequency.type,
            disabled_frequency: f.disabled
          }"
          class="milestone_card"
          :key="index"
          v-for="(f, index) in frequencies"
          v-on:click="selectUnselectFrequency(f)"
        >
          <p class="m-0 pt-5">
            <span v-if="f.title === 'Bi-annually' || f.title === 'Annually'">{{ f.title }}</span>
            <span v-else>{{ f.title }}</span>
          </p>
          <i v-if="telehealthVisit.scheduler.frequency && telehealthVisit.scheduler.frequency.type && f.type === telehealthVisit.scheduler.frequency.type" class="fa fa-info-circle p-1" aria-hidden="true"></i>
        </div>
        <div class="pt-20" v-if="telehealthVisit.telehealthVisitDTO.configFor !== 'site'">
          <label class="fw-normal">
            <input type="checkbox" name="isActivityOptional" v-model="telehealthVisit.scheduler.isActivityOptional" class="checkbox_position" />
            <span> Activity is optional and will be excluded from the compliance report</span>
          </label>
        </div>
        <div class="row">
          <div class="col-sm-4 p-0" v-if="options.validateFor !== 'notification'">
            <div class="pt-40">
              <div class="scheduler-heading here">
                What is the completion window?
                <a class="color_grey cursor_pointer" data-toggle="modal" data-target="#completionModal">
                  <i class="fa fa-info-circle p-1"></i>
                </a>
              </div>
              <input type="number" min="1" class="form-control completion_window_days" onkeypress="return event.charCode >= 48 && event.charCode <= 57" placeholder="Enter" v-model="telehealthVisit.scheduler.completionWindow" v-on:blur="calculateReminders(telehealthVisit.scheduler.completionWindow)" />
              days
            </div>
          </div>
          <div class="col-sm-8 p-0" v-if="options.validateFor === 'telehealthv2' && telehealthVisit.telehealthVisitDTO.configFor !== 'site'">
            <div class="pt-40">
              <div class="scheduler-heading">
                How far in advance can a participant schedule their Telehealth visit?
                <a class="color_grey cursor_pointer" data-toggle="modal" data-target="#completionModal">
                  <i class="fa fa-info-circle p-1"></i>
                </a>
              </div>
              <input type="number" min="1" max="99" class="form-control completion_window_days" placeholder="Enter" v-model="telehealthVisit.scheduler.advanceScheduleDays" v-on:blur="calculateReminders(telehealthVisit.scheduler.completionWindow, telehealthVisit.scheduler.advanceScheduleDays)" />
              days
            </div>
          </div>
        </div>
        <div class="pt-40">
          <div class="scheduler-heading">
            Select time period this survey should appear
            <span class="study_duration">Study ends on day {{ studyDuration }}</span>
          </div>
          <div class="pb-15" v-for="(item, index) in telehealthVisit.scheduler.duration" :key="index">
            <div class="row fs-12 color_959fa4">
              <div class="col-md-2 pl-0">Start</div>
              <div class="col-md-6 pl-0">End</div>
            </div>
            <div class="row">
              <div class="col-md-1 pl-0 pr-0">
                <span class="day_label">Day</span>
              </div>
              <div class="col-md-1 pl-0">
                <input type="number" v-validate="'required|min_value:1'" name="startDay" min="1" class="form-control" v-model="item.startDay" />
              </div>
              <div class="col-md-1 pl-0 pr-0">
                <span class="day_label">Day</span>
              </div>
              <div class="col-md-1 pl-0">
                <input type="number" min="1" class="form-control" v-validate="'required|min_value:1'" name="endDay" v-model="item.endDay" :disabled="telehealthVisit.scheduler.allowUntillDuration && index + 1 === telehealthVisit.scheduler.duration.length" />
              </div>
              <div class="col-md-2 pl-0 color_blue cursor_pointer pt-5" v-on:click="addAnotherDuration(index)" v-if="telehealthVisit.scheduler.duration.length === index + 1 && !telehealthVisit.scheduler.allowUntillDuration">
                Add another time period
              </div>
              <div class="col-md-2 pl-0 color_red cursor_pointer pt-5" v-on:click="removeDuration(index)" v-if="telehealthVisit.scheduler.duration.length !== index + 1">
                Remove
              </div>
            </div>
          </div>
          <div class="pt-10">
            <label class="fw-normal">
              <input type="checkbox" name="allowUntillDuration" v-model="telehealthVisit.scheduler.allowUntillDuration" v-on:change="allowUntilDurationChanges(telehealthVisit.scheduler.allowUntillDuration)" />
              <span class>Available until the end of participant's study duration</span>
            </label>
          </div>
        </div>
      </div>

      <div id="extended-availability">
        <div class="scheduler-heading mt-36" v-if="telehealthVisit.telehealthVisitDTO.configFor === 'participant'">
          Allow participant to schedule outside of required completion window?
          <span
            v-b-popover.hover="'Gives participant more time to schedule a visit. Once checked, you must provide the number of days the participant can extend the scheduling. Please keep any future visits in mind when determining the number of extended days. If a participant books during the extended window, the site team will be notified via confirmation email.'"
            class="fa fa-info-circle ml-7"
          ></span>
        </div>
        <div class="scheduler-heading mt-36" v-if="telehealthVisit.telehealthVisitDTO.configFor === 'site'">
          Allow site to schedule outside of required completion window?
          <span v-b-popover.hover="'Gives site more time to schedule a visit. Once checked, you must provide the number of days the site can extend the scheduling. Please keep any future visits in mind when determining the number of extended days. If a site books during the extended window, the site team will be notified via confirmation email.'" class="fa fa-info-circle ml-7"></span>
        </div>
        <div class="mt-10">
          <label for="extendedAvailabilityCheck" class="fw-normal">
            <input type="checkbox" id="extendedAvailabilityCheck" name="extendedAvailabilityCheck" v-model="telehealthVisit.telehealthVisitDTO.extendAvailability" />
            <span>&nbsp;&nbsp;Extend availability</span>
          </label>
        </div>
        <div v-if="telehealthVisit.telehealthVisitDTO.extendAvailability" class="extend-availability-input mt-10">
          <div>
            Extend completion window by
            <input type="number" min="1" onkeypress="return event.charCode >= 48 && event.charCode <= 57" class="form-control completion_window_days ml-10 mr-10" placeholder="Enter" v-model="telehealthVisit.telehealthVisitDTO.extendWindow" />
            days
          </div>
        </div>
      </div>

      <hr />
      <!-- NEW CODE ADDED -->
      <notification-edit
        @updateReminder="updateReminder"
        :options="{
          advanceScheduleDays: telehealthVisit.scheduler.advanceScheduleDays ? telehealthVisit.scheduler.advanceScheduleDays : 0,
          completionWindow: telehealthVisit.scheduler.completionWindow,
          telehealthVisit: telehealthVisit,
          reminderList: reminderList,
          remindersList: remindersList,
          appNotification: options.notificationData,
          isDataExist: options.isDataExist
        }"
        :studyData="studyData"
      />

      <div class="row mt-20">
        <div class="col-md-6">
          <span class="delete-icon" v-on:click="deleteVisit()" v-if="options.telehealthvisit != null && options.telehealthvisit != undefined">
            <img src="static/img/econsent/delete.svg" alt="Delete" />
          </span>
        </div>
        <div class="col-md-6">
          <div class="text-right">
            <button type="button" class="btn btn-outline-secondary mr-10" @click="deleteVisit()">
              Cancel
            </button>
            <button v-if="options.telehealthVisitDTO && options.telehealthVisitDTO.id === undefined" type="button" @click="addVisit()" class="btn btn-primary" :disabled="disableCreate">
              Create
            </button>
            <button v-if="options.telehealthVisitDTO && options.telehealthVisitDTO.id" type="button" @click="addVisit()" class="btn btn-primary" :disabled="disableCreate">
              Save
            </button>
          </div>
        </div>
      </div>
      <!-- NEW CODE ENDS-->
      <div id="completionModal" class="modal fade" role="dialog">
        <div class="modal-dialog">
          <!-- Modal content-->
          <div class="modal-content">
            <div>
              <div class="row text-right">
                <a class="cancelImage cursor_pointer" data-dismiss="modal">
                  <i class="fa fa-times" aria-hidden="true"></i>
                </a>
              </div>
              <div class="example">
                <p class="example-header">
                  When a task is assigned to the participant, you have the opportunity to set the window of completion for the task before it expires.
                </p>
                <div class="bg-milestone pb-40">
                  <p class="example-content text-center">
                    Example: A survey is assigned to a participant at study week 2, which for this participant happens to be a Wednesday, and a 3 day completion window has been set. The survey will be pushed to the participant on Wednesday and will be available through Friday. On Saturday morning, the survey will be removed from participantâ€™s task list and will be reported as a missed task.
                  </p>
                  <div class="row milestone">
                    <div class="col-lg-2 ml-0 pl-0 mr-0 pr-0" v-for="(milestone, index) in exampleMileStone" :key="index">
                      <div class="text-center">{{ milestone.day }}</div>
                      <div class="milestone_box" :class="{ 'white-bg': milestone.day === 'Sat' }">
                        <div
                          class="circle"
                          v-if="milestone.class"
                          :class="{
                            'bg-green': milestone.day === 'Wed',
                            'bg-red': milestone.day === 'Sat'
                          }"
                        ></div>
                      </div>
                      <div class="text-center">{{ milestone.date }}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import toastr from "toastr";
import _ from "lodash";
import NotificationEdit from "./notification-edit"; //NEW CODE ADDED
import swal from "sweetalert2"; //NEW CODE ADDED

const MODE_ICON = {
  schedule: {
    selected: "static/img/selected-scheduled-activity-icon.svg",
    unselected: "static/img/scheduled-activity-icon.svg"
  },
  both: {
    selected: "static/img/selected-scheduled-and-on-demand-activity.svg",
    unselected: "static/img/scheduled-and-on-demand-activity.svg"
  },
  onDemand: {
    selected: "static/img/selected-on-demand-activity-icon.svg",
    unselected: "static/img/on-demand-activity-icon.svg"
  }
};

const MODE = { scheduled: "scheduled", both: "both", onDemand: "onDemand" };
export default {
  name: "scheduler",
  data() {
    return {
      visitTitle: "",
      studyId: null,
      surveyId: null,
      studyData: {},
      surveyData: {},
      studyDuration: null,
      taskId: null,
      milestones: [],
      frequencies: [
        { type: "daily", title: "Daily", days: 1, disabled: false },
        { type: "weekly", title: "Weekly", days: 7, disabled: false },
        { type: "biweekly", title: "Every 2 Weeks", days: 14, disabled: false },
        { type: "monthly", title: "Monthly", days: 30, disabled: false },
        {
          type: "biannually",
          title: "Bi-annually",
          days: 182,
          disabled: false
        },
        { type: "annually", title: "Annually", days: 365, disabled: false }
      ],
      telehealthVisit: {
        scheduler: {
          type: "milestone",
          milestones: [],
          frequency: { type: null, title: null, days: null },
          startDay: null,
          endDay: null,
          completionWindows: {},
          completionWindow: null,
          reminders: [],
          allowMultipleTimes: false,
          allowUntillDuration: false,
          duration: [{ startDay: null, endDay: null }],
          activitySchedulingMode: "schedule"
        },
        telehealthVisitDTO: {
          title: "",
          activityName: "",
          sequence: 1,
          createdTime: new Date(),
          version: 1,
          status: "Initiated",
          useHTML: true,
          visitType: "telehealth",
          allowRecording: false
        }
      },
      remindersList: [],
      remindersListTeleHealth: [],
      reminderList: [
        {
          day: "default",
          message: null,
          time: {
            hh: "",
            mm: "",
            A: ""
          }
        }
      ],
      exampleMileStone: [
        { date: "Day1", day: "Wed", class: "bg-green" },
        { date: "Day2", day: "Thur", class: "" },
        { date: "Day3", day: "Fri", class: "" },
        { date: "+2", day: "Sat", class: "bg-red" }
      ],
      time: {
        hh: "",
        mm: "",
        A: ""
      },
      maxChar: 36,
      disableCreate: false,
      activitySchedulingMode: "schedule",
      activityModeIcon: {
        schedule: MODE_ICON.schedule.unselected,
        both: MODE_ICON.both.unselected,
        onDemand: MODE_ICON.onDemand.unselected
      },
      activityDataIsLoaded: false,
      defaultSchedulerObj: {
        type: "milestone",
        milestones: [],
        frequency: { type: null, title: null, days: null },
        startDay: null,
        endDay: null,
        completionWindow: null,
        reminders: [],
        allowMultipleTimes: false,
        allowUntillDuration: false,
        showDailySummary: false,
        duration: [{ startDay: null, endDay: null }],
        activitySchedulingMode: "schedule"
      },
      defaultTelehealthVisit: {
        scheduler: {
          type: "milestone",
          milestones: [],
          frequency: { type: null, title: null, days: null },
          startDay: null,
          endDay: null,
          completionWindow: null,
          reminders: [],
          callReminders: [],
          allowMultipleTimes: false,
          allowUntillDuration: false,
          duration: [{ startDay: null, endDay: null }],
          activitySchedulingMode: "schedule"
        },
        telehealthVisitDTO: {
          title: "",
          sequence: 1,
          createdTime: new Date(),
          version: "1.0",
          status: "Initiated",
          useHTML: true,
          visitType: "Telehealth",
          extendAvailability: false,
          extendWindow: "",
          allowRecording: false
        }
      },
      savedTelehealthVisit: {
        scheduler: {
          type: "milestone",
          milestones: [],
          frequency: { type: null, title: null, days: null },
          startDay: null,
          endDay: null,
          completionWindow: null,
          reminders: [],
          callReminders: [],
          allowMultipleTimes: false,
          allowUntillDuration: false,
          duration: [{ startDay: null, endDay: null }],
          activitySchedulingMode: "schedule"
        },
        telehealthVisitDTO: {
          title: "",
          sequence: 1,
          createdTime: new Date(),
          version: "1.0",
          status: "Initiated",
          useHTML: true,
          visitType: "Telehealth",
          extendAvailability: false,
          extendWindow: "",
          allowRecording: false
        }
      },
      autoSaveElementTimeout: process.env.VUE_APP_AUTO_SAVE_ELEMENT_LIB_TIMEOUT
    };
  },
  components: {
    NotificationEdit
  },
  props: ["options", "THvisitRecordingState"],
  computed: {
    telehealthVisitObjChanged() {
      return this.$store.getters.getTelehealthVisitObjData;
    },
    activityMode: {
      get: function() {
        return this.activitySchedulingMode;
      },
      set: function(mode) {
        this.activitySchedulingMode = mode;
      }
    },
    regularMilestones() {
      if (this.studyData.milestonesList) {
        if (this.studyData.screeningMilestoneAllowed && this.studyData.screeningDuration) {
          let filtered = this.studyData.milestonesList.filter(mile => mile.milestoneType != "screening");
          filtered.forEach(mile => {
            mile.milestoneDay -= this.studyData.screeningDuration;
          });
          filtered = _.sortBy(filtered, "milestoneDay");
          return filtered;
        } else {
          this.studyData.milestonesList = _.sortBy(this.studyData.milestonesList, "milestoneDay");
          return this.studyData.milestonesList;
        }
      }
      return [];
    },
    screeningMilestones() {
      if (this.studyData.milestonesList) {
        const filtered = this.studyData.milestonesList.filter(mile => mile.milestoneType == "screening");
        filtered.forEach(mile => {
          mile.milestoneDay -= this.studyData.screeningDuration;
        });
        return _.sortBy(filtered, "milestoneDay");
      }
      return [];
    }
  },
  mounted() {
    this.studyId = this.$route.params.studyId;
    this.surveyId = this.$route.params.surveyId;
    this.notificationData = this.options.notificationData;
    this.telehealthVisit.scheduler = this.options.scheduler;
    this.telehealthVisit.telehealthVisitDTO = this.options.telehealthVisitDTO;
    // store THvisit data for reference :
    this.savedTelehealthVisit.scheduler = _.cloneDeep(this.options.scheduler);
    this.savedTelehealthVisit.telehealthVisitDTO = _.cloneDeep(this.options.telehealthVisitDTO);
    this.activityMode = this.telehealthVisit.scheduler.activitySchedulingMode;
    this.setActivityModeIcon(this.activityMode);
    this.activityDataIsLoaded = true;
    this.getStudyDetails();
    this.getSchedulerDetails();
    this.startAutoSave();
  },
  watch: {
    telehealthVisitObjChanged: {
      handler(val) {
        if (val.validateFor) {
          if (val.autoSave) {
            this.checkValidation(this.telehealthVisit.scheduler, this.telehealthVisit.telehealthVisitDTO, val.autoSave);
          } else {
            this.checkValidation(this.telehealthVisit.scheduler, this.telehealthVisit.telehealthVisitDTO);
          }
        }
      }
    },
    "telehealthVisit.telehealthVisitDTO.extendAvailability": {
      handler(isChecked) {
        if (!isChecked) {
          this.telehealthVisit.telehealthVisitDTO.extendWindow = "";
        }
      }
    },
    activityMode: {
      handler(val) {
        if (val) {
          if (this.activityDataIsLoaded) {
            this.getDefaultValue(this.telehealthVisit.scheduler);
          }
        }
      }
    }
  },
  methods: {
    updateReminder(reminder) {
      this.remindersListTeleHealth = {
        callReminders: reminder.notificationList.callReminder,
        reminders: reminder.notificationList.reminder
      };
      if (this.telehealthVisit.telehealthVisitDTO.configFor === "site") {
        this.remindersListTeleHealth.siteTaskCallReminders = reminder.notificationList.siteTaskCallReminders ? reminder.notificationList.siteTaskCallReminders : [];
        delete this.remindersListTeleHealth.callReminders;
      }
    },
    setCompletionWindows(milestone, completionWindow) {
      milestone.completionWindow = Number(completionWindow);
    },
    goBack() {},
    changeType(type) {
      this.telehealthVisit.scheduler.type = type;
      this.reminderList = [
        {
          day: "default",
          message: null,
          time: {
            hh: "",
            mm: "",
            A: ""
          }
        }
      ];
      this.calculateReminders(this.telehealthVisit.scheduler.completionWindow, null);
    },
    getSchedulerDetails() {
      if (!this.telehealthVisit.scheduler.completionWindows) {
        this.telehealthVisit.scheduler.completionWindows = {};
      }
    },
    selectUnselectMileStone(milestone) {
      if (!this.telehealthVisit.scheduler.milestones) {
        this.telehealthVisit.scheduler.milestones = [];
      }
      if (!this.telehealthVisit.scheduler.completionWindows) {
        this.telehealthVisit.scheduler.completionWindows = {};
      }
      if (this.telehealthVisit.scheduler && this.telehealthVisit.scheduler.milestones && this.telehealthVisit.scheduler.milestones.indexOf(milestone) < 0) {
        this.telehealthVisit.scheduler.milestones.push(milestone);
      } else {
        this.telehealthVisit.scheduler.milestones.splice(this.telehealthVisit.scheduler.milestones.indexOf(milestone), 1);
        delete this.telehealthVisit.scheduler.completionWindows[milestone];
      }
      this.$forceUpdate();
    },
    calculateReminders(completionWindowOld) {
      let completionWindow = completionWindowOld;
      completionWindow = Number(completionWindow) === 0 ? 1 : completionWindow;
      if (completionWindow && this.remindersList) {
        // calcyclate if remider list is not present //
        this.remindersList.length = Number(completionWindow) - 1;
      }
    },
    updateMilestones() {
      window.localStorage.setItem("isSchedulerOpen", true);
      window.localStorage.setItem("visitId", 0);
      window.localStorage.setItem("designIndex", 15);
      this.$router.push({
        name: "study-design",
        params: { studyId: this.studyId }
      });
    },
    selectUnselectFrequency(frequency) {
      this.telehealthVisit.scheduler.frequency = frequency;
      this.$forceUpdate();
    },
    skipForNow() {
      this.$router.push({
        name: "survey-as-template",
        params: { studyId: this.studyId, surveyId: this.surveyId }
      });
    },
    allowUntilDurationChanges(allowUntillDuration) {
      if (allowUntillDuration) {
        this.telehealthVisit.scheduler.duration[this.telehealthVisit.scheduler.duration.length - 1].endDay = null;
      }
    },
    addAnotherDuration() {
      this.telehealthVisit.scheduler.duration.push({
        startDay: null,
        endDay: null
      });
      this.$forceUpdate();
    },
    removeDuration(index) {
      this.telehealthVisit.scheduler.duration.splice(index, 1);
      this.$forceUpdate();
    },
    getExactDayEpoch(day) {
      const newDay = new Date(day);
      return new Date(newDay.getFullYear(), newDay.getMonth(), newDay.getDate(), 0, 0, 0).getTime();
    },
    getStudyDetails() {
      this.$api.getStudyDataFact(this.studyId).then(
        response => {
          this.studyData = response.body;
          const sd = new Date(this.studyData.firstPatientEnrollDate).valueOf();
          const ed = new Date(this.studyData.firstPatientLastDate).valueOf();
          this.studyDuration = parseInt((this.getExactDayEpoch(ed) - this.getExactDayEpoch(sd)) / 1000 / 86400, 10);
          _.forEach(this.frequencies, val => {
            switch (val.type) {
              case "daily":
                val.disabled = this.studyDuration < 1;
                break;
              case "weekly":
                val.disabled = this.studyDuration < 7;
                break;
              case "biweekly":
                val.disabled = this.studyDuration < 15;
                break;
              case "monthly":
                val.disabled = this.studyDuration < 30;
                break;
              case "biannually":
                val.disabled = this.studyDuration < 180;
                break;
              case "annually":
                val.disabled = this.studyDuration < 365;
                break;
              default:
                break;
            }
          });
        },
        error => {
          toastr.error(error.body ? error.body.message : "Error while getting the study details");
        }
      );
    },
    findMinDiff(val) {
      let s = val;
      let m, i, j;
      // eslint-disable-next-line no-eval
      s = eval(s);
      m = Math.abs(s[(i = 0)] - s[(j = 1)]);
      for (; i < s.length; i++) {
        j = i;
        for (++j; j < s.length; ++j) {
          const newV = Math.abs(s[i] - s[j]);
          m = newV < m ? newV : m;
        }
      }
      return m;
    },
    isSorted(arr) {
      const len = arr.length - 1;
      for (let i = 0; i < len; ++i) {
        if (arr[i] > arr[i + 1]) {
          return false;
        }
      }
      return true;
    },
    validateCustomType(scheduler, properList, autoSave) {
      if (scheduler.advanceScheduleDays % 1 !== 0) {
        if (!autoSave) {
          toastr.error("Advance scheduling days cannot have decimals.");
        }
        this.disableCreate = false;
        return false;
      } else if (scheduler.advanceScheduleDays < 0) {
        if (!autoSave) {
          toastr.error("Advance scheduling days should be between 0 and 99.");
        }
        this.disableCreate = false;
        return false;
      }
      let minDuration = 365;
      for (let i = 0; i < properList.length / 2; i++) {
        if (properList[i + i + 2] && properList[i + i + 1] && minDuration > properList[i + i + 2] - properList[i + i + 1]) {
          minDuration = properList[i + i + 2] - properList[i + i + 1] - 1;
        }
      }
      const fcwDiff = scheduler.frequency.days - scheduler.completionWindow;
      minDuration = minDuration > fcwDiff ? fcwDiff : minDuration;
      if (scheduler.advanceScheduleDays > minDuration) {
        if (minDuration !== 0) {
          if (!autoSave) {
            toastr.error(`Number of advanced days can be between 0 and ${minDuration}`);
          }
          this.disableCreate = false;
        } else if (minDuration === 0) {
          if (!autoSave) {
            toastr.error("Number of advanced days can be 0 only");
          }
          this.disableCreate = false;
        }
      } else {
        return scheduler.advanceScheduleDays <= minDuration;
      }
    },
    validateMilestoneType(possibleVal, valid, scheduler, mArr, milestones, autoSave = false) {
      let validScheduler = valid;
      let minDiff = null;
      if (possibleVal && validScheduler) {
        if (scheduler.advanceScheduleDays === null || scheduler.advanceScheduleDays === undefined) {
          validScheduler = false;
          if (!autoSave) {
            toastr.error("Please enter advance days.");
          }
          this.disableCreate = false;
          return;
        } else if (scheduler.advanceScheduleDays % 1 !== 0) {
          validScheduler = false;
          if (!autoSave) {
            toastr.error("Advance days cannot have decimals.");
          }
          this.disableCreate = false;
          return;
        } else if (scheduler.advanceScheduleDays < 0) {
          validScheduler = false;
          if (!autoSave) {
            toastr.error("Advance days cannot be in Negative.");
          }
          this.disableCreate = false;
          return;
        }
      }
      if (mArr.length !== 0) {
        // when multiple milestones are selected
        const milestoneArr = _.sortBy(mArr);
        const diffArr = [];
        let screeningDuration = 0;
        if (this.studyData.screeningMilestoneAllowed) {
          screeningDuration = this.studyData.screeningDuration;
        }
        if (this.studyData.screeningMilestoneAllowed && milestoneArr[0] < 0) {
          const valMile = milestoneArr[0] * -1;
          diffArr[0] = this.studyData.screeningDuration - valMile;
        } else {
          diffArr[0] = milestoneArr[0];
        }
        for (let i = 1; i < milestoneArr.length; i++) {
          const completionWindows = scheduler.completionWindows[milestoneArr[i - 1]];
          diffArr[i] = milestoneArr[i] + screeningDuration - (milestoneArr[i - 1] + screeningDuration + Number(completionWindows));
        }
        minDiff = _.min(diffArr);
      } else {
        // when one milestone is selected
        minDiff = milestones[0] !== 0 ? milestones[0] - 1 : 0;
      }
      if (scheduler.milestones.length === 1) {
        minDiff = scheduler.milestones[0];
      }

      if (this.studyData.screeningMilestoneAllowed && minDiff < 0) {
        minDiff = minDiff * -1;
      }

      if (scheduler.advanceScheduleDays > minDiff) {
        if (minDiff !== 0) {
          if (!autoSave) {
            toastr.error(`Number of advanced days can be between 0 and ${minDiff}`);
          }
          this.disableCreate = false;
        } else if (minDiff === 0) {
          if (!autoSave) {
            toastr.error("Number of advanced days can be 0 only");
            this.disableCreate = false;
          }
        }
      } else {
        return scheduler.advanceScheduleDays <= minDiff && validScheduler;
      }
    },
    checkValidation(originalScheduler, originalTelehealthVisisDTO, autoSave = false) {
      const scheduler = { ...originalScheduler };
      const telehelathVisit = { ...originalTelehealthVisisDTO };
      const getSelectedVisitTypes = _.filter(this.telehealthVisit.telehealthVisitDTO.visitTypes, data => data.selected == true);
      if (this.remindersListTeleHealth.callReminders || this.remindersListTeleHealth.reminders || this.remindersListTeleHealth.siteTaskCallReminders) {
        scheduler.reminders = this.remindersListTeleHealth.reminders.length > 0 ? this.remindersListTeleHealth.reminders : [];
        if (this.telehealthVisit.telehealthVisitDTO.configFor === "site") {
          scheduler.siteTaskCallReminders = this.remindersListTeleHealth.siteTaskCallReminders.length > 0 ? this.remindersListTeleHealth.siteTaskCallReminders : [];
          delete scheduler.callReminders;
        } else {
          scheduler.callReminders = this.remindersListTeleHealth.callReminders.length > 0 ? this.remindersListTeleHealth.callReminders : [];
        }
      }
      if (this.telehealthVisit.telehealthVisitDTO.configFor === "site" && scheduler.siteTaskCallReminders && scheduler.siteTaskCallReminders.length > 0) {
        scheduler.siteTaskCallReminders.map(data => {
          if (data.id && data.action === undefined) {
            data.action = "None";
          }
        });
      }

      if (this.telehealthVisit.telehealthVisitDTO.title == undefined || this.telehealthVisit.telehealthVisitDTO.title == "" || this.telehealthVisit.telehealthVisitDTO.title == null) {
        if (!autoSave) {
          toastr.error("Visit name is required");
        }
        this.disableCreate = false;
      } else if (!this.telehealthVisit.telehealthVisitDTO.activityName || this.telehealthVisit.telehealthVisitDTO.activityName.trim() == "") {
        if (!autoSave) {
          toastr.error("Activity name is required");
        }
        this.disableCreate = false;
      } else if (this.telehealthVisit.telehealthVisitDTO.activityName.trim().length > this.maxChar) {
        if (!autoSave) {
          toastr.error(`Activity name must be under ${this.maxChar} characters`);
        }
        this.disableCreate = false;
      } else if (this.telehealthVisit.telehealthVisitDTO.visitType == undefined || this.telehealthVisit.telehealthVisitDTO.visitType == "" || this.telehealthVisit.telehealthVisitDTO.visitType == null) {
        if (!autoSave) {
          toastr.error("Please select a visit type");
        }
        this.disableCreate = false;
      } else if (this.telehealthVisit.telehealthVisitDTO.extendAvailability == true && (this.telehealthVisit.telehealthVisitDTO.extendWindow == "" || this.telehealthVisit.telehealthVisitDTO.extendWindow < 0)) {
        if (!autoSave) {
          toastr.error("Please specify the # of extra days");
        }
        this.disableCreate = false;
      } else if (getSelectedVisitTypes.length === 0) {
        if (!autoSave) {
          toastr.error("Please select any one Type of Visit");
        }
        this.disableCreate = false;
      } else if (this.telehealthVisit.telehealthVisitDTO.configFor === "") {
        if (!autoSave) {
          toastr.error("Please select who will be able to schedule the visit");
        }
        this.disableCreate = false;
      } else {
        let formVisitTypeString = null;
        _.map(getSelectedVisitTypes, (dataSelected, dtIndex) => {
          if (dtIndex === 0) {
            formVisitTypeString = dataSelected.visitType;
          } else {
            formVisitTypeString = formVisitTypeString + "|" + dataSelected.visitType;
          }
        });
        telehelathVisit.title = this.telehealthVisit.telehealthVisitDTO.title;
        telehelathVisit.activityName = this.telehealthVisit.telehealthVisitDTO.activityName;
        telehelathVisit.visitType = formVisitTypeString;
        delete telehelathVisit.visitTypes;

        scheduler.taskId = this.surveyId ? this.surveyId : "";
        scheduler.taskType = this.options.validateFor;
        scheduler.taskTitle = this.telehealthVisit.telehealthVisitDTO.activityName;
        scheduler.activitySchedulingMode = this.activityMode;
        let milestoneArr = [];
        let minDiff = null;
        let possibleVal = null;
        let validScheduler = true;
        let allDaysList = null;
        let properList = null;
        let durationValues = null;
        scheduler.completionWindow = scheduler.completionWindow ? Number(scheduler.completionWindow) : null;
        if (this.options.validateFor === "telehealthv2") {
          scheduler.advanceScheduleDays = scheduler.advanceScheduleDays || scheduler.advanceScheduleDays === 0 ? Number(scheduler.advanceScheduleDays) : null;
          scheduler.taskId = this.taskId;
        }
        scheduler.taskType = "telehealth";
        // When activity is scheduled for "onDemand"
        if (this.activityMode && this.activityMode === "onDemand") {
          scheduler.taskId = this.scheduler.taskId;
          scheduler.type = "onDemand";
          const dispatchObj = {};
          dispatchObj.schedulerObj = scheduler;
          dispatchObj.telehelathVisitObj = telehelathVisit;
          if (!autoSave) {
            this.$store.dispatch("telehealthVisitAction", {
              validatedFor: this.options.validateFor,
              telehealthVisitObj: dispatchObj
            });
          } else {
            this.$store.dispatch("telehealthVisitAction", {
              validatedFor: this.options.validateFor,
              telehealthVisitObj: dispatchObj,
              autoSave: autoSave
            });
          }
          return;
        }
        //scheduler.taskTitle = this.telehealthVisit.telehealthVisitDTO.activityName;
        // if telehealth visti type is in person then set recording always false
        if (telehelathVisit.visitType == "In-person") {
          telehelathVisit.allowRecording = false;
        }
        switch (scheduler.type) {
          case "milestone":
            if (scheduler.taskType !== "notification") {
              if (!scheduler.milestones || scheduler.milestones.length <= 0) {
                if (!autoSave) {
                  toastr.error("Please select a milestone");
                }
                validScheduler = false;
                this.disableCreate = false;
              } else if (this.studyDuration <= scheduler.completionWindow) {
                validScheduler = false;
                if (!autoSave) {
                  toastr.error("Specified completion window cannot exceed study duration");
                }
                this.disableCreate = false;
              } else if (scheduler.milestones.length === 1) {
                possibleVal = this.studyDuration - scheduler.milestones[0] - 1;
                possibleVal = possibleVal === 0 ? 1 : possibleVal;
                if (possibleVal < scheduler.completionWindow) {
                  validScheduler = false;
                  if (!autoSave) {
                    toastr.error("Specified completion window overlaps with another milestone");
                  }
                  this.disableCreate = false;
                } else if (scheduler.taskType === "truclinic" && scheduler.advanceScheduleDays > 99) {
                  validScheduler = false;
                  if (!autoSave) {
                    toastr.error("Advanced days cannot be more than 99");
                  }
                  this.disableCreate = false;
                }
              } else if (scheduler.taskType === "telehealth" && telehelathVisit.configFor === "participant" && (scheduler.advanceScheduleDays === null || scheduler.advanceScheduleDays === undefined)) {
                validScheduler = false;
                if (!autoSave) {
                  toastr.error("Please enter value for advanced days");
                }
                this.disableCreate = false;
                return;
              } else {
                milestoneArr = _.map(scheduler.milestones, _.ary(parseInt, 1));
                milestoneArr.sort();
                minDiff = this.findMinDiff(milestoneArr);
                possibleVal = minDiff;
                possibleVal = possibleVal === 0 ? 1 : possibleVal;
                if (possibleVal < scheduler.completionWindow) {
                  validScheduler = false;
                  if (!autoSave) {
                    toastr.error("Specified completion window overlaps with another milestone");
                  }
                  this.disableCreate = false;
                }
              }
            } else if (scheduler.milestones.length <= 0) {
              // for notifications only
              if (!autoSave) {
                toastr.error("Please select a milestone");
              }
              validScheduler = false;
            }
            if (this.studyData.milestonesList) {
              const milestoneList = this.studyData.milestonesList;
              this.telehealthVisit.scheduler.milestones.sort((a, b) => a - b);
              for (let i = 0; i < milestoneList.length; i++) {
                const milestoneDay = milestoneList[i].milestoneDay;
                let completionWindow = this.telehealthVisit.scheduler.completionWindows[milestoneDay];
                const selectedMilestoneIndex = this.telehealthVisit.scheduler.milestones.indexOf(milestoneDay);
                const nextSelectedMilestoneDay = this.telehealthVisit.scheduler.milestones[selectedMilestoneIndex + 1];
                const milestoneType = milestoneList[i].milestoneType ? milestoneList[i].milestoneType : "";
                completionWindow = Number(completionWindow);

                if (this.telehealthVisit.scheduler.milestones.indexOf(milestoneDay) < 0) {
                  continue;
                }
                if (!completionWindow) {
                  if (!autoSave) {
                    toastr.error("Number of days for completion window is required.");
                  }
                  this.disableCreate = false;
                  return;
                } else if (completionWindow < 1) {
                  if (!autoSave) {
                    toastr.error("Please specify completion window with value greater than 0.");
                  }
                  this.disableCreate = false;
                  return;
                } else if (completionWindow > this.studyDuration) {
                  if (!autoSave) {
                    toastr.error("Specified completion window cannot exceed study duration.");
                  }
                  this.disableCreate = false;
                  return;
                } else if (milestoneType == "screening" && completionWindow > this.studyData.screeningDuration) {
                  if (!autoSave) {
                    toastr.error(`Specified completion window cannot exceed ${milestoneType} duration.`);
                  }
                  this.disableCreate = false;
                  return;
                } else if (!!nextSelectedMilestoneDay && milestoneDay + completionWindow > nextSelectedMilestoneDay) {
                  if (!autoSave) {
                    if (milestoneType == "screening") {
                      toastr.error(`Specified completion window overlaps with another ${milestoneType} milestone.`);
                    } else {
                      toastr.error("Specified completion window overlaps with another milestone.");
                    }
                  }
                  this.disableCreate = false;
                  return;
                }
                if (milestoneType == "screening" && (nextSelectedMilestoneDay > 0 || !nextSelectedMilestoneDay)) {
                  if (milestoneDay + completionWindow > 0) {
                    if (!autoSave) {
                      toastr.error(`Specified completion window cannot exceed ${milestoneType} duration.`);
                    }
                    this.disableCreate = false;
                    return;
                  }
                }
              }
            }
            if (validScheduler && scheduler.taskType === "telehealth" && telehelathVisit.configFor === "participant" && !this.validateMilestoneType(possibleVal, validScheduler, scheduler, milestoneArr, scheduler.milestones)) {
              validScheduler = false;
            }

            if (validScheduler) {
              const schedulerCopy = _.cloneDeep(scheduler);
              if (this.studyData.screeningMilestoneAllowed && this.studyData.screeningDuration) {
                for (let i = 0; i < schedulerCopy.milestones.length; i++) {
                  schedulerCopy.milestones[i] += this.studyData.screeningDuration;
                }
                schedulerCopy.completionWindows = this.filteredCompletionWindowsForSaving(schedulerCopy.completionWindows);
              }

              const dispatchObj = {};
              dispatchObj.schedulerObj = schedulerCopy;
              dispatchObj.telehelathVisitObj = telehelathVisit;
              if (!autoSave) {
                this.$store.dispatch("telehealthVisitAction", {
                  validatedFor: this.options.validateFor,
                  telehealthVisitObj: dispatchObj
                });
              } else {
                this.$store.dispatch("telehealthVisitAction", {
                  validatedFor: this.options.validateFor,
                  telehealthVisitObj: dispatchObj,
                  autoSave: autoSave
                });
              }
            }
            break;
          case "custom":
            this.$validator.validateAll().then(valid => {
              scheduler.frequency = scheduler.frequency ? scheduler.frequency : { type: null, title: null, days: null };
              durationValues = _.map(scheduler.duration, item => ({
                startDay: parseFloat(item.startDay),
                endDay: parseFloat(item.endDay)
              }));
              allDaysList = _.flatten(_.map(durationValues, o => [o.startDay, o.endDay]));
              properList = _.compact(allDaysList);
              properList = scheduler.allowUntillDuration && properList % 2 === 0 ? _.dropRight(properList) : properList;
              if (scheduler.taskType !== "notification" && (!scheduler.frequency.type || !scheduler.completionWindow)) {
                if (!autoSave) {
                  toastr.error(!scheduler.frequency.type ? "Please select a frequency" : "Please specify completion window");
                }
                this.disableCreate = false;
              } else if (scheduler.taskType === "notification" && !scheduler.frequency.type) {
                if (!autoSave) {
                  toastr.error("Please select a frequency");
                  this.disableCreate = false;
                }
              } else if (scheduler.taskType !== "notification" && (scheduler.completionWindow <= 0 || scheduler.completionWindow % 1 !== 0)) {
                if (!autoSave) {
                  toastr.error("Completion window should be greater than 0 and cannot have decimals");
                }
                this.disableCreate = false;
              } else if (scheduler.taskType !== "notification" && scheduler.completionWindow > scheduler.frequency.days) {
                if (!autoSave) {
                  toastr.error("Completion window cannot exceed the length of the frequency");
                }
                this.disableCreate = false;
              } else if (!scheduler.allowUntillDuration && allDaysList.length !== properList.length && !scheduler.allowUntillDuration && allDaysList.length !== properList.length - 1 && !this.studyData.screeningMilestoneAllowed) {
                if (!autoSave) {
                  toastr.error("Start and End days should be greater than 0 and cannot have decimals");
                }
                this.disableCreate = false;
              } else if (this.errors.any() && !valid && !this.studyData.screeningMilestoneAllowed) {
                if (!autoSave) {
                  toastr.error("Start/End day should be greater than 0 and cannot have decimals");
                }
                this.disableCreate = false;
              } else if (!this.isSorted(properList)) {
                if (!autoSave) {
                  toastr.error("Start and end days should be in increasing order.");
                }
                this.disableCreate = false;
              } else if (_.uniq(properList).length !== properList.length) {
                if (!autoSave) {
                  toastr.error("Scheduled start and end days overlap. Please revise.");
                }
                this.disableCreate = false;
              } else if (this.studyData.screeningMilestoneAllowed && _.max(properList) > this.studyData.studyDuration) {
                if (!autoSave) {
                  toastr.error("Start and end day should be less than study & screening duration.");
                }
                this.disableCreate = false;
              } else if (this.studyData.screeningMilestoneAllowed && _.min(properList) < -this.studyData.screeningDuration) {
                if (!autoSave) {
                  toastr.error("Start Day cannot be less than screening duration");
                }
                this.disableCreate = false;
              } else if (this.studyData.screeningMilestoneAllowed && scheduler.allowUntillDuration && durationValues[0].startDay < -this.studyData.screeningDuration) {
                if (!autoSave) {
                  toastr.error("Start Day cannot be less than screening duration");
                }
                this.disableCreate = false;
              } else if (!this.studyData.screeningMilestoneAllowed && _.max(properList) > this.studyDuration) {
                if (!autoSave) {
                  toastr.error("Start and end day should be less than study duration");
                }
                this.disableCreate = false;
              } else if (scheduler.taskType === "telehealth" && telehelathVisit.configFor === "participant" && (scheduler.advanceScheduleDays === null || scheduler.advanceScheduleDays === undefined)) {
                if (!autoSave) {
                  toastr.error("Please enter value for advance days");
                }
                this.disableCreate = false;
              } else if (scheduler.taskType === "telehealth" && telehelathVisit.configFor === "participant" && !this.validateCustomType(scheduler, properList, autoSave)) {
              } else {
                if (this.studyData.screeningMilestoneAllowed) {
                  let schedulerDurationCopy = [];
                  schedulerDurationCopy = _.cloneDeep(scheduler.duration);
                  schedulerDurationCopy.forEach(duration => {
                    Object.keys(duration).forEach(key => {
                      if (duration[key] !== null) {
                        duration[key] = Number(parseInt(duration[key]) + this.studyData.screeningDuration);
                      }
                    });
                  });
                  scheduler.duration = schedulerDurationCopy;
                }

                const dispatchObj = {};
                dispatchObj.schedulerObj = scheduler;
                dispatchObj.telehelathVisitObj = telehelathVisit;
                if (!autoSave) {
                  this.$store.dispatch("telehealthVisitAction", {
                    validatedFor: this.options.validateFor,
                    telehealthVisitObj: dispatchObj
                  });
                } else {
                  this.$store.dispatch("telehealthVisitAction", {
                    validatedFor: this.options.validateFor,
                    telehealthVisitObj: dispatchObj,
                    autoSave: autoSave
                  });
                }
              }
            });
            break;
          default:
            break;
        }
      }
    },
    filteredCompletionWindowsForSaving(completionWindows) {
      const newCompletion = {};

      Object.keys(completionWindows).forEach(key => {
        const newKey = Number(key) + Number(this.studyData.screeningDuration);
        newCompletion[newKey] = Number(completionWindows[key]);
      });

      return newCompletion;
    },
    addVisit(autoSave = false) {
      if (!autoSave) {
        this.disableCreate = true;
        this.$store.dispatch("telehealthVisitAction", {
          validateFor: "telehealthv2"
        });
      } else {
        this.disableCreate = true;
        this.$store.dispatch("telehealthVisitAction", {
          validateFor: "telehealthv2",
          autoSave: autoSave
        });
      }
    },
    deleteVisit() {
      swal({
        title: "Are you sure you want to cancel?",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#b8c7ce",
        cancelButtonColor: "#f16559",
        confirmButtonText: "Cancel",
        cancelButtonText: "Yes"
      }).then(({ dismiss }) => {
        if (dismiss === "cancel") {
          //TODO save the Visit
          this.$emit("exit");
        }
      });
    },
    changeActivityMode(mode) {
      this.activityMode = mode;
      this.setActivityModeIcon(mode);
    },
    setActivityModeIcon(mode) {
      for (const prop in this.activityModeIcon) {
        if (prop === mode) {
          this.activityModeIcon[prop] = MODE_ICON[prop]["selected"];
        } else {
          this.activityModeIcon[prop] = MODE_ICON[prop]["unselected"];
        }
      }
      if (mode === "onDemand") {
        if (!this.options.telehealthVisitDTO.id) {
          //milestones
          this.telehealthVisit.scheduler.milestones = this.telehealthVisit.scheduler.milestones ? [] : this.telehealthVisit.scheduler.milestones;
          this.telehealthVisit.scheduler.completionWindow = this.telehealthVisit.scheduler.completionWindow ? null : this.telehealthVisit.scheduler.completionWindow;
          this.telehealthVisit.scheduler.completionWindows = this.telehealthVisit.scheduler.completionWindows ? {} : this.telehealthVisit.scheduler.completionWindows;
          //Custom frequency
          this.telehealthVisit.scheduler.frequency = this.telehealthVisit.scheduler.frequency.days || this.telehealthVisit.scheduler.frequency.type ? { type: null, title: null, days: null } : this.telehealthVisit.scheduler.frequency;
          this.telehealthVisit.scheduler.duration = this.telehealthVisit.scheduler.duration[0].startDay || this.telehealthVisit.scheduler.duration[0].endDay ? [{ startDay: null, endDay: null }] : this.telehealthVisit.scheduler.duration;
        }
      }
    },
    getDefaultValue(scheduler) {
      const selectedMode = this.activityMode;
      if (selectedMode) {
        if (selectedMode !== MODE.onDemand) {
          // when either 'Scheduled' or 'Scheduled & On-demand' type button is selected
          let savedMode;
          if (this.telehealthVisit.telehealthVisitDTO.id) {
            // if activity has saved scheduler | case: edit
            savedMode = this.telehealthVisit.scheduler.activitySchedulingMode;
          } else {
            // if activity has no saved scheduler | case: add/edit
            savedMode = scheduler.activitySchedulingMode;
          }

          if (selectedMode !== savedMode) {
            this.initialize("empty", _.cloneDeep(this.defaultTelehealthVisit.scheduler), this.defaultTelehealthVisit);
          } else {
            if (this.telehealthVisit.telehealthVisitDTO.id) {
              // if activity has saved scheduler
              this.initialize("fill", _.cloneDeep(this.savedTelehealthVisit.scheduler), this.savedTelehealthVisit);
            } else {
              // if activity has no saved scheduler
              this.initialize("empty", _.cloneDeep(this.defaultTelehealthVisit.scheduler), this.defaultTelehealthVisit);
            }
          }
        } else {
          this.scheduler = {
            taskId: scheduler.taskId,
            taskType: scheduler.taskType,
            activitySchedulingMode: selectedMode,
            taskTitle: this.telehealthVisit.telehealthVisitDTO.title
          };
        }
      }
    },
    initialize(type, scheduler, data) {
      const isEmpty = type => {
        return type === "empty";
      };
      const isFill = type => {
        return type === "fill";
      };
      this.telehealthVisit.scheduler = scheduler && isFill(type) ? scheduler : _.cloneDeep(this.defaultTelehealthVisit.scheduler);
      if (!this.telehealthVisit.scheduler.duration || this.telehealthVisit.scheduler.duration.length === 0 || isEmpty(type)) {
        this.telehealthVisit.scheduler.duration = [{ startDay: null, endDay: null }];
      }
      this.telehealthVisit.telehealthVisitDTO.allowRecording = data.telehealthVisitDTO.allowRecording;
    },
    changeVisitType(type) {
      let getVisitIndex = -1;
      if (type === "Telehealth") {
        this.telehealthVisit.telehealthVisitDTO.visitType = "Telehealth";
        getVisitIndex = this.telehealthVisit.telehealthVisitDTO.visitTypes.findIndex(data => data.visitType === "Telehealth");
        this.telehealthVisit.telehealthVisitDTO.visitTypes[getVisitIndex].selected = !this.telehealthVisit.telehealthVisitDTO.visitTypes[getVisitIndex].selected;
      } else if (type === "In-person") {
        this.telehealthVisit.telehealthVisitDTO.visitType = "In-person";
        getVisitIndex = this.telehealthVisit.telehealthVisitDTO.visitTypes.findIndex(data => data.visitType === "In-person");
        this.telehealthVisit.telehealthVisitDTO.visitTypes[getVisitIndex].selected = !this.telehealthVisit.telehealthVisitDTO.visitTypes[getVisitIndex].selected;
      } else if (type === "Homevisit") {
        getVisitIndex = this.telehealthVisit.telehealthVisitDTO.visitTypes.findIndex(data => data.visitType === "Homevisit");
        this.telehealthVisit.telehealthVisitDTO.visitTypes[getVisitIndex].selected = !this.telehealthVisit.telehealthVisitDTO.visitTypes[getVisitIndex].selected;
      } else if (type === "Phonecall") {
        getVisitIndex = this.telehealthVisit.telehealthVisitDTO.visitTypes.findIndex(data => data.visitType === "Phonecall");
        this.telehealthVisit.telehealthVisitDTO.visitTypes[getVisitIndex].selected = !this.telehealthVisit.telehealthVisitDTO.visitTypes[getVisitIndex].selected;
      }
      this.$forceUpdate();
    },
    changeScheduleVisitType(type) {
      if (this.telehealthVisit.telehealthVisitDTO.id) {
      } else {
        this.telehealthVisit.telehealthVisitDTO.configFor = type;
        if (type === "site") {
          this.changeActivityMode("schedule");
        }
        this.$forceUpdate();
      }
    },
    startAutoSave() {
      this.$root.$emit("isAutoSaveTHScheduler", false);
      this.autoSaveTimer = setInterval(() => {
        if (Date.now() >= (Number(this.autoSaveElementTimeout) + window.document.getIdleSecondsCounter())) {
          clearInterval(this.autoSaveTimer);
          this.addVisit(true);
        }
      }, 1000);
    },
    stopAutoSave() {
      this.$root.$emit("isAutoSaveTHScheduler", true);
      clearInterval(this.autoSaveTimer);
    }
  },
  beforeRouteLeave(to, from, next) {
    this.$root.$emit("isAutoSaveTHScheduler", true);
    this.addVisit(true);
    setTimeout(() => {
      next();
    }, 100);
  },
  beforeDestroy() {
    this.$root.$emit("isAutoSaveTHScheduler", true);
    this.stopAutoSave();
  }
};
</script>

<style lang="scss">
.bg-green {
  background-color: #2ecc71 !important;
}

.bg-red {
  background-color: #ff7171 !important;
}
.scheduler-heading {
  font-weight: 600;
  color: #666769;
}

.container-style {
  border-radius: 2px;
  background-color: #ffffff;
  color: #666769;
  box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.1);
}
.error-style {
  font-size: 12px;
  color: #ff4848;
  padding-bottom: 5px;
}
.study_duration {
  display: inline-block;
  color: #4c8ce4;
  background-color: #edf3fc;
  padding: 2px 5px;
  border-radius: 2px;
}
.completion_window_days {
  width: 100px;
  display: inline-block;
}
.example {
  margin: 40px 40px 20px 40px;
}
.example-content {
  padding: 20px 40px 20px 40px;
}
.bg-milestone {
  background-color: #f5f8fa;
}
.example-header {
  padding: 20px 80px 10px 80px;
  font-weight: bold;
}

.milestone_box {
  border: 1px solid #34537d;
  width: 60px;
  height: 10px;
  padding-top: 1px;
  padding-bottom: 9px;
  border-radius: 100px;
  background-color: #34537d;
}
.disabled_frequency {
  pointer-events: none;
  background-color: #ddd !important;
}
.scheduler_types {
  margin-top: 8px;
  .scheduler_type {
    cursor: pointer;
    border: 1px solid #ccc;
    padding: 10px;
    border-radius: 2px;
    min-height: 52px;
    display: inline-block;
    background-color: #fff;
  }
  .scheduler_type:not(:first-child) {
    margin-left: 10px;
  }
  .type_icon_bg {
    background-color: #ddd;
    width: 28px;
    height: 28px;
    display: inline-block;
    border-radius: 100%;
    padding: 3px;
    text-align: center;
  }
  .active_item {
    border: 1px solid #32557a;
    background-color: #32557a;
    color: #fff;
    .type_icon_bg {
      background-color: #488ee1;
    }
  }
}
.day_label {
  display: block;
  width: 100%;
  height: 34px;
  padding: 6px 12px;
  font-size: 14px;
  line-height: 1.42857143;
  color: #888;
  background-color: #fafafa;
  background-image: none;
  border: 1px solid #ccc;
}
.milestone {
  padding: 0px 12px 0px 120px;
}

.circle {
  width: 7px;
  height: 8px;
  background-color: white;
  border-radius: 100px;
  margin-left: 3px;
}

.completion-window {
  background-color: #c5d1d6;
  display: flex;
  padding: 0 4px;
  border-radius: 3px;
  padding: 8px 4px 4px 11px;
  margin-top: -4px;
}
.completion-window > p {
  padding-top: 8px;
  margin: 0;
  font-size: 12px;
  font-family: Roboto;
  line-height: 1.33;
  text-align: left;
  color: #34537d;
}
.completion-window > input {
  border: none;
  width: 50px;
  height: 32px;
  border-radius: 2px;
  text-align: center;
  background-color: #ffffff;
  color: #666669;
  padding: 5px;
}

.milestone_card {
  cursor: pointer;
  min-width: 160px;
  border: solid 1px #d3dfe4;
  background-color: #fff;
  border-radius: 2px;
  display: inline-block;
  padding: 8px 10px;
  margin: 13px 10px 10px 0;
  min-height: 52px;
  color: #c5d1d6;
}
.selected_completion_window {
  background-color: #32557a;
  border-radius: 4px;
  min-height: 52px;
  color: #fff;
  position: relative;
  vertical-align: top;
  cursor: pointer;
  min-width: 160px;
  border: solid 1px #d3dfe4;
  display: inline-block;
  margin: 13px 9px 10px 0;
  .fa {
    position: absolute;
    right: 10px;
    top: 8px;
    font-size: 32px;
    color: #488ee1;
  }
  .day_text {
    color: #ddd;
    font-size: 12px;
  }
  .day_card {
    padding: 10px 8px;
    min-width: 180px;
  }
}
.selected_milestone {
  background-color: #32557a;
  border-radius: 4px;
  min-height: 52px;
  color: #fff;
  position: relative;
  .fa {
    position: absolute;
    right: 10px;
    top: 8px;
    font-size: 32px;
    color: #488ee1;
  }
  .day_text {
    color: #fff;
    font-size: 12px;
  }
}
.day_text {
  color: #c5d1d6;
  font-size: 12px;
}
.edit_milestone_link {
  font-size: 12px;
  padding-left: 10px;
  position: relative;
  color: #4c8ce3;
  cursor: pointer;
}
.add_another_btn {
  font-size: 12px;
  background-color: transparent;
  border-color: #f06559;
  color: #f06559;
  margin-bottom: 20px;
  max-width: 180px;
}

.create_milestone_btn {
  font-size: 12px;
  background-color: #f06559;
  border-color: #f06559;
  color: #fff;
  margin-bottom: 20px;
  max-width: 180px;
}

.disabled-bg {
  pointer-events: none;
  // background-color: #e7ebef;
  /deep/ input {
    // color: red;
    background-color: #e7ebef;
  }
}
.time-picker input.display-time {
  background-color: #e7ebef;
  border-radius: 2px;
}
.pt-40 {
  padding-top: 40px;
}

.form-control {
  border-radius: 2px;
}

.text-color {
  color: #888;
}

.cancelImage {
  color: #959fa4;
  position: absolute;
  right: 10px;
  top: 7px;
  font-size: 24px;
}

.card {
  padding: 15px;
  color: black;
}
//New css added
.telehealth-v2 {
  .scheduler-heading {
    color: #4a4a4a;
  }
  .scheduler_types .scheduler_type:not(:first-child),
  .visit-types .type:not(:first-child) {
    margin-left: 0;
    margin-right: 10px;
  }
  .scheduler_types .type_icon_bg {
    vertical-align: middle;
    padding: 6px;
  }
  .scheduler_types .scheduler_type {
    border-radius: 4px;
    padding: 11px 15px;
  }
  button {
    &.btn-primary {
      background-color: #1e8fe1;
      border-color: #1e8fe1;
    }
  }
  .btn {
    min-width: 100px;
    height: 34px;
    line-height: inherit;
  }
  .col-md-4 {
    padding-left: 0;
  }
  .col-sm-6,
  .col-md-6,
  .col-lg-3 {
    padding-left: 0px;
    padding-right: 0px;
  }
  .fa-info-circle {
    color: #b4bbbf;
  }
  .telehealth_qs {
    font-weight: 600;
    color: #666769;
  }

  .activity-mode {
    margin-bottom: 30px;
    display: inline-flex;
    & span {
      padding: 16px 28px 16px 11px;
      margin-right: 13px;
      background: #fff;
      border-radius: 3px;
      border: solid 1px #d3dfe4;
      font-size: 15px;
      @media screen and (max-width: 768px) {
        white-space: nowrap;
        margin-top: auto;
        margin-bottom: auto;
        padding: 16px 20px 16px 11px !important;
      }
      &.selected {
        background: #34537d;
        color: #fff;
      }
      &:hover {
        cursor: pointer;
      }
    }
  }

  .activity-mode-opacity {
    display: none;
  }

  .activity-mode {
    margin-bottom: 26px;
    display: inline-block;
    & span {
      padding: 16px 28px 16px 11px;
      margin-right: 13px;
      background: #fff;
      border-radius: 3px;
      border: solid 1px #d3dfe4;
      font-size: 15px;
      &.selected {
        background: #34537d;
        color: #fff;
      }
      &:hover {
        cursor: pointer;
      }
    }
  }

  .activity-mode-opacity {
    visibility: hidden;
  }
  .visit-types {
    margin-top: 8px;
    .type {
      cursor: pointer;
      border: 1px solid #ccc;
      padding: 10px 15px;
      border-radius: 4px;
      min-height: 52px;
      display: inline-block;
      background-color: #fff;
      .icon {
        position: relative;
        vertical-align: middle;
        display: inline-block;
      }

      .type-telehealth {
        background: url("/static/img/telehealth/visit-type-telehealth.svg") no-repeat center;
        height: 30px;
        width: 32px;
      }

      .in-person {
        background: url("/static/img/telehealth/in-person.svg") no-repeat center;
        height: 30px;
        width: 32px;
      }
      .office-visit {
        background: url("/static/img/telehealth/office-visit.svg") no-repeat center;
        height: 30px;
        width: 32px;
      }
      .phone-call {
        background: url("/static/img/telehealth/phone-call.svg") no-repeat center;
        height: 30px;
        width: 32px;
      }

      .home-visit {
        background: url("/static/img/telehealth/home-visit.svg") no-repeat center;
        height: 30px;
        width: 32px;
      }
      .participant-logo {
        background: url("/static/img/telehealth/participant-IconInactive.svg") no-repeat center;
        height: 30px;
        width: 32px;
      }

      .siteTeam-logo {
        background: url("/static/img/side-menu-icons/icn-team.svg") no-repeat center;
        height: 30px;
        width: 32px;
      }

      .both {
        background: url("/static/img/telehealth/Config_Both_off.svg") no-repeat center;
        height: 30px;
        width: 59px;
      }

      &.active_item {
        .type-telehealth {
          background: url("/static/img/telehealth/visit-type-telehealth-active.svg") no-repeat center;
          height: 30px;
          width: 30px;
        }
        .in-person {
          display: inline-block;
          background: url("/static/img/telehealth/in-person-active.svg") no-repeat center;
          height: 30px;
          width: 32px;
        }
        .office-visit {
          background: url("/static/img/telehealth/office-visit-active.svg") no-repeat center;
          height: 30px;
          width: 32px;
        }
        .participant-logo {
          background: url("/static/img/telehealth/participant-IconActive.svg") no-repeat center;
          height: 30px;
          width: 32px;
        }
        .siteTeam-logo {
          background: url("/static/img/telehealth/SiteTeam_Active.png") no-repeat center;
          height: 30px;
          width: 32px;
        }
        .phone-call {
          background: url("/static/img/telehealth/phone-call-active.svg") no-repeat center;
          height: 30px;
          width: 32px;
        }
        .both {
          background: url("/static/img/telehealth/Config_Both_on.svg") no-repeat center;
          height: 30px;
          width: 59px;
        }
      }
    }

    /* .type_icon_bg {
      background-color: #ddd;
      width: 28px;
      height: 28px;
      display: inline-block;
      border-radius: 100%;
      padding: 3px;
      text-align: center;
    } */
    .active_item {
      border: 1px solid #32557a;
      background-color: #32557a;
      color: #fff;
      /* .type_icon_bg {
        background-color: #488ee1;
      } */
    }
  }
}

.popover {
  font-size: 12px !important;
  font-family: "Lato-regular" !important;
}

.popover-body {
  color: #666666 !important;
}

#extended-availability {
  input[type="checkbox"] {
    vertical-align: middle;
  }
}

.visit-recording {
  & .disabled {
    opacity: 0.4;
  }
  & .checkbox {
    width: 1rem;
    height: 1rem;
    margin-right: 7px;
    display: inline-block;
  }
  & .control-label {
    padding-left: 6px;
    height: 16px;
    vertical-align: middle;
  }
  & .control-label::before,
  .control-label::after {
    top: 0.8rem;
    width: 1rem;
    height: 1rem;
  }
}
.scheduleVisitTxt {
  color: #4a4a4a;
  padding-top: 2rem;
  font-weight: bold;
}
.activeText {
  color: #fff;
}
.in-activeText {
  color: #c5d1d6;
  font-weight: bold;
}
.mileStoneText {
  font-weight: bold;
}
.not-allowed {
  cursor: not-allowed;
}
.notShownCSS {
  color: #4a4a4a;
  background-color: #eeeeee;
  padding: 2px;
  border-radius: 2px;
  font-family: Roboto;
  margin: -24px -11px 0px 0px;
  float: right;
  font-size: 10px;
}
.selectedNotShownCSS {
  margin: -16px 0px 0px 0px;
}
.scheduler-type-custom {
  display: none;
}
</style>
